<script setup lang="ts">
import { Skeleton } from '@/components/ui/skeleton'
import { Stepper, StepperItem, StepperSeparator, StepperTrigger } from '@/components/ui/stepper'
</script>

<template>
    <div>
        <div class="relative flex w-full items-start gap-5 pb-4">
            <Stepper orientation="vertical" class="flex w-full flex-col justify-start gap-12 overflow-hidden">
                <StepperItem v-for="index in 5" :key="`${index}-skeleton`" class="relative flex w-full items-start gap-6" :step="index + 1">
                    <StepperSeparator
                        v-show="5 !== index"
                        class="absolute top-[35px] left-[15px] block h-[100%] w-0.5 shrink-0 rounded-full bg-gray-200 group-data-[disabled]:bg-gray-200 group-data-[disabled]:opacity-100"
                    />

                    <StepperTrigger as-child class="flex size-8 items-center justify-center rounded-full">
                        <div class="bg-gray-100">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
                                    fill="#6B7280"
                                />
                            </svg>
                        </div>
                    </StepperTrigger>
                    <div class="flex w-full flex-col justify-between gap-1">
                        <div class="flex flex-col gap-1">
                            <Skeleton class="h-6 w-64" />
                            <Skeleton class="h-4 w-16" />
                        </div>
                        <div class="mt-2 space-y-1">
                            <Skeleton class="h-4 w-3/12" />
                            <Skeleton class="h-4 w-3/12" />
                            <Skeleton class="h-4 w-3/12" />
                        </div>
                    </div>
                </StepperItem>
            </Stepper>
        </div>
    </div>
</template>
